import React, { useState, Fragment } from 'react';
import { View, ScrollView } from 'react-native';
import { storiesOf } from '@storybook/react-native';
import { PanelHeader, PanelHeaderBack, PanelHeaderClose } from 'src/components/PanelHeader';
import { PlatformPadding } from 'src/components/PlatformPadding';
import { Button } from 'src/components/Button';
import { Text, Subheading } from 'src/components/Typography';
import { Separator } from 'src/components/Separator';
import { Sheet } from './Sheet';

const Example1 = () => {
  const [shortSheetActive, toggleShortSheet] = useState(false);
  const [longSheetActive, toggleLongSheet] = useState(false);
  const [cardSheetActive, toggleCardSheet] = useState(false);

  return (
    <Fragment>
      <PanelHeader>🚀 Sheet</PanelHeader>
      <PlatformPadding vertical horizontal>
        <View>
          <Button onPress={() => toggleShortSheet(true)}>Show Short Sheet</Button>
          <Separator />
          <Button onPress={() => toggleLongSheet(true)}>Show Long Sheet</Button>
          <Separator />
          <Button onPress={() => toggleCardSheet(true)}>Show Custom Sheet</Button>
        </View>
      </PlatformPadding>
      <Sheet
        visible={shortSheetActive}
        onRequestClose={() => toggleShortSheet(false)}
        onDismiss={() => console.log('sheet dismissed')}
      >
        <PanelHeader
          right={
            <PanelHeaderClose onPress={() => toggleShortSheet(false)}>Cancel</PanelHeaderClose>
          }
        >
          Short Sheet Header
        </PanelHeader>
        <PlatformPadding horizontal>
          <View>
            <Text>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias assumenda consectetur
              cumque deleniti deserunt et exercitationem facere, fugit molestias mollitia natus
              nostrum numquam, obcaecati quo reiciendis sequi soluta tenetur vero?
            </Text>
            <Separator size="xxl" />
            <Button onPress={() => toggleShortSheet(false)}>Close Sheet</Button>
          </View>
        </PlatformPadding>
      </Sheet>
      <Sheet visible={longSheetActive} onRequestClose={() => toggleLongSheet(false)}>
        <PanelHeader
          separator={false}
          left={<PanelHeaderBack onPress={() => toggleLongSheet(false)} />}
        >
          Long Sheet Header
        </PanelHeader>
        <ScrollView style={{ flexShrink: 1 }}>
          <PlatformPadding horizontal>
            <Text>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aut consectetur deserunt
              eius expedita fugit hic illum, laborum neque obcaecati odit officia, pariatur quae quo
              repudiandae temporibus. Aperiam asperiores blanditiis dolor, doloremque esse eum
              eveniet exercitationem illo labore maiores maxime minus officia quam sequi suscipit
              temporibus tenetur. Ad asperiores consequuntur culpa cum delectus ducimus eaque earum
              et, eveniet ex facere harum in incidunt ipsa magni maiores maxime modi mollitia
              nostrum numquam officia placeat praesentium quas quidem quisquam quo recusandae,
              repellendus vel vero voluptas voluptatem, voluptates voluptatibus voluptatum?
              Accusantium alias animi, est hic molestias mollitia perferendis quas? Aperiam
              asperiores debitis dicta, dolorem eius hic id iure labore laboriosam, maiores nostrum
              porro ratione tenetur ullam veritatis! Accusantium, adipisci animi assumenda culpa
              deserunt distinctio dolor ducimus eos ex fuga fugiat, illo ipsa ipsam iusto laboriosam
              libero maxime minima minus nesciunt nulla numquam obcaecati officia omnis pariatur
              placeat porro recusandae sapiente sequi soluta tempora temporibus ullam voluptas
              voluptatibus? Atque blanditiis dicta error exercitationem maxime mollitia non
              reprehenderit sequi ut voluptates? A ab cum debitis eaque fugiat magnam magni nesciunt
              non odio quo repellendus, vitae. Commodi, delectus dolorum est hic impedit labore odit
              officia sequi sunt voluptas? Amet beatae iure maiores omnis sapiente! Consectetur
              cumque deserunt eveniet maiores molestiae nemo nobis, officia praesentium quisquam
              tempore. A accusamus ad aliquid animi aperiam aspernatur consequatur deleniti deserunt
              dicta dolores enim eos, exercitationem explicabo facilis, fuga illo, laboriosam magnam
              nisi nulla obcaecati officiis optio recusandae rerum sed sint totam vel voluptas
              voluptate voluptates voluptatum. Dolores facere maiores quasi tempora?
            </Text>
          </PlatformPadding>
        </ScrollView>
        <PlatformPadding horizontal>
          <View>
            <Separator size="xxl" />
            <Button onPress={() => toggleLongSheet(false)}>Close Sheet</Button>
          </View>
        </PlatformPadding>
      </Sheet>
      <Sheet visible={cardSheetActive} onRequestClose={() => toggleCardSheet(false)}>
        <PanelHeader separator={false}>Would you like to pass a test?</PanelHeader>
        <PlatformPadding horizontal>
          <View>
            <Subheading>
              To discover your language level and become familiar with app functions.
            </Subheading>
            <Separator size="xxl" />
            <Button onPress={() => toggleCardSheet(false)}>Yes, of course</Button>
            <Separator size="m" />
            <Button variant="secondary" onPress={() => toggleCardSheet(false)}>
              Maybe later
            </Button>
          </View>
        </PlatformPadding>
      </Sheet>
    </Fragment>
  );
};

storiesOf('Sheet', module).add('Default', () => <Example1 />);
